import type { ApiFetch, IncomeRecord, TransactionPageResponse } from "@aera/data-table";

function normalizeIncomeRecord(raw: Record<string, unknown>): IncomeRecord {
  const record = { ...raw } as IncomeRecord;
  if (record.created_at && !record.recorded_at) {
    record.recorded_at = String(record.created_at);
  }
  return record;
}

function pickRecord(rows: IncomeRecord[], recordId: string): IncomeRecord | null {
  const target = recordId.trim();
  if (!target) return null;
  const exact = rows.find(
    (row) => String(row.record_id ?? "").trim() === target,
  );
  return exact ?? rows[0] ?? null;
}

/** Load one รายรับ row from the same transactions API as the ข้อมูล tab. */
export async function fetchBillLinIncomeRecord(
  workspaceId: string,
  recordId: string,
  fetcher: ApiFetch = fetch,
): Promise<IncomeRecord | null> {
  const ws = workspaceId.trim();
  const id = recordId.trim();
  if (!ws || !id) return null;

  const load = async (params: Record<string, string>) => {
    const qs = new URLSearchParams({
      worker: "bill-lin-income",
      workspace_id: ws,
      limit: "50",
      ...params,
    });
    const res = await fetcher(`/api/v1/transactions?${qs.toString()}`);
    if (!res.ok) return [] as IncomeRecord[];
    const payload = (await res.json()) as TransactionPageResponse;
    return (payload.data ?? []).map((row) =>
      normalizeIncomeRecord(row as Record<string, unknown>),
    );
  };

  const byId = await load({ record_id: id });
  const hitById = pickRecord(byId, id);
  if (hitById && String(hitById.record_id ?? "").trim() === id) return hitById;

  const bySearch = await load({ q: id });
  const hitBySearch = pickRecord(bySearch, id);
  if (hitBySearch) return hitBySearch;

  return null;
}
